import { render } from "./LeeConfirm.vue?vue&type=template&id=0df41ae2&ts=true"
import script from "./LeeConfirm.vue?vue&type=script&lang=ts"
export * from "./LeeConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__